import styled from 'styled-components';

import { COLORS, GRADIENTS, SHADOWS } from '@components/web/src/styles';

export const DetachFidelityCardButton = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 4px 14px;
  color: ${COLORS.base.white};
  background: ${GRADIENTS.primaryGradient};
  border: none;
  border-radius: 8px;
  box-shadow: ${SHADOWS.xs};
`;
